<div class="w-full mt-5">
  <app-button
    variant="primary"
    [disabled]="disabled()"
    [fullWidth]="true"
    [isLoading]="isLoading()"
    [text]="buttonText()"
    [type]="type()"
    (clicked)="clicked.emit()"
  />

  <div
    *ngIf="showHint()"
    class="flex justify-center items-center gap-2 text-sm mt-2"
  >
    <span class="text-dark-grey">{{ hintText() }}</span>

    <button
      class="underline text-blue"
      [routerLink]="route()"
    >
      {{ linkText() }}
    </button>
  </div>
</div>
